import List from './src/main';
export default List;